import React, { useRef } from 'react';
import { object, func } from 'prop-types';
import { CaretRight } from '@nike/nike-design-system-icons';
import { TextStyled } from '@nike/nike-design-system-components';
import Link from '../Link';
import { MENU_OPTION_CLASS } from '../MobileMenu/styles';

/**
 * this was created so a linkRef could be created per link and passed into state
 * so we could return focus to the sub menu that this link might spawn
 * @param {object} props
 * @param {object} props.mainMenuLink
 * @param {string} props.mainMenuLink.label the text of the link
 * @param {Array} props.mainMenuLink.children needed to know if we should send an analytics event
 * @param {func} props.openSubMenuClosure the data needed to open a sub menu lives one step
 * above this function but we need to pass along linkRef as well. this way we can supply
 * all the data needed and minimize the props needed to pass into this component.
 * @returns {React.ReactElement}
 */
const MobileShoppingMenuLink = ({ mainMenuLink, openSubMenuClosure }) => {
  const linkRef = useRef(null);
  const containsChildren = Boolean(mainMenuLink?.children?.length);
  const keyDownHandler = ({ nativeEvent }) => {
    switch (nativeEvent.which) {
      case 32: // SPACE
        openSubMenuClosure(linkRef);
        break;

      default:
        break;
    }
  };

  const handleOnClick = () => {
    if (containsChildren) {
      openSubMenuClosure(linkRef);
    }
  };

  return (
    <Link
      appearance="title3"
      className={MENU_OPTION_CLASS}
      href={containsChildren ? null : mainMenuLink?.url}
      onClick={handleOnClick}
      onKeyDown={keyDownHandler}
      ref={linkRef}
      shouldSendEvent={containsChildren}
    >
      <TextStyled appearance="title3">{mainMenuLink?.label}</TextStyled>
      {containsChildren && <CaretRight />}
    </Link>
  );
};
MobileShoppingMenuLink.propTypes = {
  mainMenuLink: object,
  openSubMenuClosure: func,
};
export default MobileShoppingMenuLink;
